import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AddRecipientModal } from '../../message-modals/add-recipient/add-recipient';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataTableComponent } from '../../ui/data-table/data-table.component';

@Component({
  selector: 'legacy-add-segments-modal',
  standalone: true,
  imports: [CommonModule, AddRecipientModal, FormsModule, ReactiveFormsModule, DataTableComponent],
  templateUrl: './add-segments-component.html',
  styleUrls: ['./add-segments-modal.css'],
})
export class AddSegmentsModal {
  @Input() data: any[] = []; // Pass data from parent
  @Input() add_recipient: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() selectedSegmentsChange = new EventEmitter<any[]>();
  @Input() selectedSegments: any[] = [];

  // Form control for search input
  searchControl = new FormControl('');

  // Track selected segments and search query
  segments_list: any[] = [];
  allSelectedSegments = false;
  searchParam: string = '';

  constructor(
    private router: Router,
    private contactsService: ContactsService
  ) {}

  // Close modal
  closeModal(): void {
    this.close.emit();
  }

  // fetchOrganisations(): void {
  //   this.contactsService.fetchOrganizations({
  //     'name.contains': this.searchParam,
  //   });

  //   this.contactsService.getOrganizations.subscribe({
  //     next: (data) => {
  //       this.org_list = data.map((org) => ({
  //         ...org,
  //         selected: this.selectedOrg.some(
  //           (selected) => selected.uuid === org.uuid
  //         ),
  //       }));
  //     },
  //     error: (err) => {
  //       console.error('Error fetching organisations:', err);
  //     },
  //   });
  // }

  // Fetch segments from service
  fetchSegments(): void {
    this.contactsService.fetchSegments({
      'name.contains': this.searchParam,
    });

    this.contactsService.getSegments.subscribe({
      next: (data) => {
        this.segments_list = data.map((segment) => ({
          ...segment,
          selected: this.selectedSegments.some(
            (selected) => selected.id === segment.id
          ),
        }));
      },
      error: (err) => {
      },
    });
  }

  // Update search query and fetch new segments
  getSearchParam(searchTerm: string): void {
    this.searchParam = searchTerm;
    this.fetchSegments();
  }

  // Toggle selection of all segments
  toggleAllTags(event: any): void {
    this.allSelectedSegments = event.target.checked;
    this.segments_list.forEach((segment) => {
      segment.selected = this.allSelectedSegments;
    });
    this.updateSelectedSegments();
  }

  // Update selected segments based on checkbox state
  checkSelectionSegment(): void {
    this.updateSelectedSegments();
  }

  // Update selectedSegments array and emit to parent component
  updateSelectedSegments(): void {
    this.selectedSegments = this.segments_list.filter(
      (segment) => segment.selected
    );
    this.selectedSegmentsChange.emit([...this.selectedSegments]);
  }

  // Persist selected segments to localStorage
  persistSelectedSegments(): void {
    localStorage.setItem(
      'selectedSegments',
      JSON.stringify(this.selectedSegments)
    );
  }

  // Load previously selected segments from localStorage
  loadSelectedSegments(): void {
    const savedSegments = localStorage.getItem('selectedSegments');
    if (savedSegments) {
      this.selectedSegments = JSON.parse(savedSegments);
      this.segments_list = this.segments_list.map((seg) => ({
        ...seg,
        selected: this.selectedSegments.some(
          (selectedSegment) => selectedSegment.id === seg.id
        ),
      }));
    }
  }

  // Filter data based on search term
  filterData(searchTerm: string, param = 'message_subject'): any[] {
    if (!searchTerm) {
      return this.data;
    }
    return this.data.filter((item) =>
      item[param].toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Lifecycle method: onInit
  ngOnInit(): void {
    this.fetchSegments();

    // Reactive search input listener
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: any) => {
        this.searchParam = value;
        this.fetchSegments();
      });

    // Load previously selected segments
    this.loadSelectedSegments();
  }

  // // Lifecycle method: onDestroy
  // ngOnDestroy(): void {
  //   this.persistSelectedSegments(); // Persist selected segments on component destroy
  // }

  // Lifecycle method: onChanges
  ngOnChanges(): void {
    // Update selected state of segments when selectedSegments input changes
    this.segments_list.forEach((segment) => {
      segment.selected = this.selectedSegments.some(
        (selectedSegment) => selectedSegment.id === segment.id
      );
    });
  }
}
